import React from 'react';
import Popup from "reactjs-popup";
import author from '../author.png';

export default class AboutSection extends React.Component {
    //state = {
    //    open: false,
    //};

    //onOpenModal = () => {
    //    this.setState({ open: true });
    //};

    //onCloseModal = () => {
    //    this.setState({ open: false });
    //};

    render() {
        //const { open } = this.state;
        return (
            <div>
                <div className={"imgAuthorContainer"}>
                    <img className={"imgAuthor"} src={author} alt="author" />
                </div>             
            <div >
                <Popup  trigger={<div className="aboutButton">
                        Read about the Author
                    </div>} modal >
                    {close => (
                        <div className="modal">
                            <button className="close" onClick={close}>
                                &times;
                            </button>
                            <div className="header1"> About the author </div>
                            <div className="content">
                                Dr. Miche{'\u00E1'}l Cahill serves as the Vice President of Performance and Sports Science at 
                                Athlete Training and Health (ATH), located in Texas, USA. He oversees the program and coaching 
                                philosophy within ATH for all training strands, the development of all coaches within ATH and 
                                the daily integration of training services between hospital, academic and professional sports 
                                team partners. Miche{'\u00E1'}l has previously worked as the Director of Sports Science at Jesuit College 
                                in Dallas, catering for the needs of 750 athletes from 21 sports from 2013 - 2018.
                                Miche{'\u00E1'}l has worked with a vast array of athletes across multiple disciplines 
                                spanning from national level marathon runners to NFL players. Miche{'\u00E1'}l completed his undergraduate 
                                and Master's degrees in Ireland whilst working in inter-county Gaelic Football and running his own 
                                personal training and sports conditioning consultancy. Cahill obtained his PhD at Auckland University 
                                of Technology, New Zealand focusing on acceleration and resisted sprinting in young athletes. 
                                He is currently a Research Associate at Auckland University of Technology and Cardiff Metropolitan 
                                University supervising postgraduate research across an array of areas in performance, fitness and health.

                            </div>
                            <div className="actions">

                            </div>
                        </div>
                    )}
                </Popup>
                </div>
                </div>
        );
    }
}